/**
 * @template T
 * @param {T | undefined} value
 * @returns {value is T}
 */
export function isDefined(value) {
  return typeof value !== 'undefined';
}

/**
 * @template T
 * @param {T | Function} value
 * @returns {value is Function}
 */
export function isFunction(value) {
  return typeof value === 'function';
}

/**
 * @template T
 * @param {T | Record<string, unknown>} value
 * @returns {value is Record<string, unknown>}
 */
export function isObject(value) {
  // NOTE: this is not fully correct, because of null, we have explicit test
  // that this behavior. Not sure why we need it.
  return typeof value === 'object';
}

/**
 * @template T
 * @param {T | string} value
 * @returns {value is string}
 */
export function isString(value) {
  return typeof value === 'string' || value instanceof String;
}

/**
 * Is value a number or string representing a number?
 *
 * @template T
 * @param {T | number | string} value
 * @returns {value is number | string}
 */
export function isNumberRepresentation(value) {
  return (
    // NOTE: this is not fully correct, because of NaN and padding spaces, it
    // works now and users will see an error in tracker debugger if something goes wrong.
    // To be investigated if we want to fix it.
    // @ts-expect-error
    typeof value === 'number' || (isString(value) && !isNaN(value) && value !== '')
  );
}
